module.exports = __webpack_public_path__ + "1f8cbbfb98c37b81338e9a9d7e31f434.svg";